import { ACTIONS, categories, labels } from '../helpers/analytics-utils/constants';
import trackClickEvent from '../helpers/analytics-utils/track-event';
export const createStoreClickTracker = tracker => label => {
  tracker(categories.NATIONAL, ACTIONS.clicked, labels.createStore(label));
};
export const createCategoryClickTracker = tracker => label => {
  tracker(categories.NATIONAL, ACTIONS.clicked, labels.createCategory(label));
};
export const createTheEditStoryClickTracker = tracker => label => {
  tracker(categories.THE_EDIT, ACTIONS.clicked, labels.STORY(label));
};
export const createTheEditDeckClickTracker = tracker => label => {
  tracker(categories.THE_EDIT_DECK, ACTIONS.clicked, labels.STORY(label));
};
export const storeClickTracker = createStoreClickTracker(trackClickEvent);
export const categoryClickTracker = createCategoryClickTracker(trackClickEvent);
export const storyClickTracker = createTheEditStoryClickTracker(trackClickEvent);
export const theEditDeckClickTracker = createTheEditDeckClickTracker(trackClickEvent);